import { lazy, Suspense } from "react";
import DisclaimerSection from "@/components/DisclaimerSection";
import FAQSection from "@/components/FAQSection";
import HeroSection from "@/components/HeroSection";
import Layout from "@/components/Layout";
import SchemaBreadcrumb from "@/components/SchemaBreadcrumb";
import SchemaFAQ from "@/components/SchemaFAQ";
import SEOHead from "@/components/SEOHead";

// Lazy load below-the-fold components to reduce initial bundle and avoid forced reflow from embla-carousel
const LatestNewsSection = lazy(
	() => import("@/components/home/LatestNewsSection"),
);
const AudienceSection = lazy(() => import("@/components/home/AudienceSection"));
const TimelineSection = lazy(() => import("@/components/home/TimelineSection"));
const LawsSection = lazy(() => import("@/components/LawsSection"));
const UsefulLinksSection = lazy(
	() => import("@/components/home/UsefulLinksSection"),
);
const IntroSection = lazy(() => import("@/components/IntroSection"));
const NewsletterSection = lazy(() => import("@/components/NewsletterSection"));
const QuestionForm = lazy(() => import("@/components/QuestionForm"));

// Minimal loading fallback for sections
const SectionLoader = () => (
	<div className="py-16 flex items-center justify-center">
		<div className="animate-pulse w-full max-w-4xl h-48 bg-muted/30 rounded-2xl" />
	</div>
);

const Index = () => {
	return (
		<Layout>
			<SEOHead
				title="CIB — Cadastro Imobiliário Brasileiro | Portal Informativo"
				description="Tudo sobre o Cadastro Imobiliário Brasileiro (o CPF dos Imóveis): notícias, prazos, dicionário, cursos e ferramentas em um portal informativo independente."
				canonicalUrl="/"
				keywords="CIB, Cadastro Imobiliário Brasileiro, CPF dos Imóveis, registro de imóveis, lei do CIB, cartório de registro de imóveis, SINTER, regularização fundiária, CRECI, COFECI, corretor de imóveis"
			/>
			<SchemaFAQ />
			<SchemaBreadcrumb />

			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
				<HeroSection />
				<FAQSection />
				<Suspense fallback={<SectionLoader />}>
					<QuestionForm />
				</Suspense>
				<Suspense fallback={<SectionLoader />}>
					<LatestNewsSection />
				</Suspense>
			</div>

			<Suspense fallback={<SectionLoader />}>
				<AudienceSection />
			</Suspense>
			<Suspense fallback={<SectionLoader />}>
				<TimelineSection />
			</Suspense>
			<Suspense fallback={<SectionLoader />}>
				<LawsSection />
			</Suspense>
			<Suspense fallback={<SectionLoader />}>
				<UsefulLinksSection />
			</Suspense>
			<Suspense fallback={<SectionLoader />}>
				<IntroSection />
			</Suspense>

			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
				<Suspense fallback={<SectionLoader />}>
					<NewsletterSection />
				</Suspense>
			</div>

			<DisclaimerSection />
		</Layout>
	);
};

export default Index;
